import { MsalService } from '@azure/msal-angular';

export function logAccountAndRoles(msal: MsalService) {
  const active = msal.instance.getActiveAccount();
  const accounts = msal.instance.getAllAccounts();

  console.log('[MSAL] allAccounts:', accounts.map(a => ({ username: a.username, homeAccountId: a.homeAccountId })));
  console.log('[MSAL] activeAccount:', active);

  const claims = (active?.idTokenClaims ?? {}) as any;
  console.log('[MSAL] idTokenClaims keys:', Object.keys(claims));
  console.log('[MSAL] roles:', claims.roles ?? null);
  console.log('[MSAL] tid:', claims.tid ?? null);
}
